import ClientForm from './form'
import SearchBar from './search-bar'
import ClientTable from './table'

export {
  ClientForm,
  SearchBar,
  ClientTable,
}



// WEBPACK FOOTER //
// ./src/components/client/index.js